document.addEventListener("DOMContentLoaded", function () {
    const slider = document.querySelector(".announcement-swiper");

    if (!slider) return;

    new Swiper(slider, {
        loop: true,
        slidesPerView: 1,
        speed: 1500,
        autoplay: {
            delay: 3000,
            disableOnInteraction: false,
            pauseOnMouseEnter: true
        },
        allowTouchMove: true
    });
});